import { render, staticRenderFns } from "./plan-details.vue?vue&type=template&id=416e00a8&"
import script from "./plan-details.vue?vue&type=script&lang=js&"
export * from "./plan-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports